export default __webpack_public_path__ + "static/media/news5.f15a0008.jpg";